<script setup lang="ts">
import type { CommandItemBaseProps } from "./types";
import { SmileIcon } from "lucide-vue-next";
import SuggestionListItem from "../suggestions/SuggestionListItem.vue";

const props = defineProps<CommandItemBaseProps>();

function run() {
  props.editor
    .chain()
    .focus()
    .deleteRange(props.range)
    .startEmoji()
    .run();
}

defineExpose({ run });
</script>

<template>
  <SuggestionListItem
    :icon="SmileIcon"
    shortcut=":"
    @click="run"
    @keydown.enter="run"
  >
    Emoji
  </SuggestionListItem>
</template>
